import { faCalculator, faDollarSign, faEdit } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import React from 'react'
import { withRouter } from 'react-router-dom'
import Header from '../Header/Header'
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import useEditArticuloPrecio from './hooks/useEditArticuloPrecio'

function EditArticuloPrecio({ history, match }) {
    const { initialValues, validationSchema, handleSubmit } = useEditArticuloPrecio(history, match)

    return (
        <>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faCalculator} title={'Editar precio de artículo'} />
                </div>
                <div className="bg-gris p-4">
                    <Formik
                        enableReinitialize
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ isSubmitting }) => (
                            <Form>
                                <div className="form-row">
                                    <div className="form-group col-md-6">
                                        <label htmlFor="codigoArticulo">Código de artículo</label>
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="inputGroupPrepend">
                                                <FontAwesomeIcon icon={faCalculator} />
                                            </span>
                                            <Field
                                                type="text"
                                                id="codigoArticulo"
                                                name="codigoArticulo"
                                                className="form-control"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label htmlFor="precio">Precio</label>
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="inputGroupPrepend">
                                                <FontAwesomeIcon icon={faDollarSign} />
                                            </span>
                                            <Field
                                                type="number"
                                                id="precio"
                                                name="precio"
                                                className="form-control"
                                                placeholder="Ej. $100"
                                                step="any"
                                            />
                                        </div>
                                        <small className="form-text text-danger">
                                            <ErrorMessage name="precio" />
                                        </small>
                                    </div>
                                </div>
                                <div className="text-center">
                                    <button
                                        type="submit"
                                        className="btn btn-outline-danger"
                                        disabled={isSubmitting}
                                    >
                                        <FontAwesomeIcon icon={faEdit} /> Editar precio de artículo
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </>
    )
}

export default withRouter(EditArticuloPrecio)
